import { render, staticRenderFns } from "./PagamentosEstornar.vue?vue&type=template&id=67f9b218&"
import script from "./PagamentosEstornar.vue?vue&type=script&lang=js&"
export * from "./PagamentosEstornar.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports